/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_View_Related_LabelInputs */

const en_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View related events`)
};

const fr_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les evenements associes`)
};

const de_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ähnliche Ereignisse anzeigen`)
};

const it_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza eventi correlati`)
};

const ru_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотреть связанные события`)
};

const es_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver eventos relacionados`)
};

const zh_cn2_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看相关活动`)
};

const ja_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連イベントを見る`)
};

const hi_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संबंधित कार्यक्रम देखें`)
};

const pt_pt2_manual_qc_view_related_label = /** @type {(inputs: Manual_Qc_View_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja os eventos relacionados`)
};

/**
* | output |
* | --- |
* | "View related events" |
*
* @param {Manual_Qc_View_Related_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_view_related_label = /** @type {((inputs?: Manual_Qc_View_Related_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_View_Related_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_view_related_label(inputs)
	if (locale === "de") return de_manual_qc_view_related_label(inputs)
	if (locale === "it") return it_manual_qc_view_related_label(inputs)
	if (locale === "ru") return ru_manual_qc_view_related_label(inputs)
	if (locale === "es") return es_manual_qc_view_related_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_view_related_label(inputs)
	if (locale === "ja") return ja_manual_qc_view_related_label(inputs)
	if (locale === "hi") return hi_manual_qc_view_related_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_view_related_label(inputs)
	return en_manual_qc_view_related_label(inputs)
});